import { render, staticRenderFns } from "./EventsSection.vue?vue&type=template&id=11b8e16e&scoped=true"
import script from "./EventsSection.vue?vue&type=script&lang=js"
export * from "./EventsSection.vue?vue&type=script&lang=js"
import style0 from "./EventsSection.vue?vue&type=style&index=0&id=11b8e16e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8e16e",
  null
  
)

export default component.exports